// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3kfpO","title":"AfterFrontImage_title__2TYCu"};